/*
  The Shelf (homepage shop-by-name tabs)
  --------------------------------------
  One buy box lives in the DOM at a time. A tab click updates the static copy
  (name, rating, good-for, chips, image) from the tab's data attributes, then
  fetches /products/<handle>?section_id=shelf-panel and swaps in the
  [data-shelf-buybox] from that response. Inline scripts in the swapped HTML
  (the engraving snippet) are re-executed so the engraving tick box keeps
  working; the product-form and variant-radios custom elements upgrade on
  insertion, so option changes and Add to cart use the theme's normal flow.

  Also handled here:
    - the tick-box toggle for a two-value Without/With option (decanter):
      clicking it flips the underlying radios and fires a change event so
      global.js VariantRadios does its usual work; the price difference is
      shown next to the label
    - the panel photo gallery: the buy box ships a small JSON list of the
      product's photos (URLs only); arrows, swipe and a counter step through
      them, and the selected variant's photo is jumped to on option change.
      Photos load only when shown; neighbours preload after the first swipe.
*/
(function () {
  function initShelf(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-shelf-tab]'));
    var slot = root.querySelector('[data-shelf-buybox-slot]');
    if (!tabs.length || !slot) return;

    var cache = {};
    var current = null;

    /* gallery state */
    var gallery = [];
    var gIndex = 0;
    var interacted = false;
    var media = root.querySelector('.shelf__media');
    var prevBtn = root.querySelector('[data-shelf-prev]');
    var nextBtn = root.querySelector('[data-shelf-next]');
    var counter = root.querySelector('[data-shelf-count]');

    function setText(sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text || '';
    }

    function setImage(src, alt) {
      var img = root.querySelector('[data-shelf-image]');
      if (!img || !src) return;
      img.removeAttribute('srcset');
      img.src = src;
      if (alt !== undefined) img.alt = alt || '';
    }

    function setStatic(tab) {
      var d = tab.dataset;
      setText('[data-shelf-name]', d.name);
      setText('[data-shelf-good]', d.good);

      var rating = root.querySelector('[data-shelf-rating]');
      if (rating) {
        var count = parseInt(d.count, 10) || 0;
        if (count > 0 && d.rating) {
          rating.hidden = false;
          setText('[data-shelf-rating-value]', d.rating);
          setText('[data-shelf-rating-count]', count + (count === 1 ? ' review' : ' reviews'));
        } else {
          rating.hidden = true;
        }
      }

      var chips = root.querySelector('[data-shelf-chips]');
      if (chips) {
        chips.innerHTML = '';
        (d.tags || '').split('|').forEach(function (t) {
          if (!t) return;
          var s = document.createElement('span');
          s.textContent = t;
          chips.appendChild(s);
        });
      }

      var ribbon = root.querySelector('[data-shelf-ribbon]');
      if (ribbon) {
        ribbon.textContent = d.ribbon || '';
        ribbon.hidden = !d.ribbon;
      }

      setImage(d.image, d.name);

      var pdp = root.querySelector('[data-shelf-pdp]');
      if (pdp && d.url) pdp.href = d.url;
    }

    /* innerHTML never runs <script>; rebuild each one so inline code executes. */
    function runScripts(container) {
      var scripts = Array.prototype.slice.call(container.querySelectorAll('script'));
      scripts.forEach(function (old) {
        var type = (old.getAttribute('type') || '').toLowerCase();
        if (type && type !== 'text/javascript' && type !== 'module') return; // JSON data blocks stay as-is
        var src = old.getAttribute('src');
        if (src) {
          if (document.querySelector('script[src="' + src + '"]:not([data-shelf-clone])') || document.querySelector('script[data-shelf-clone][src="' + src + '"]')) {
            old.parentNode.removeChild(old);
            return;
          }
        }
        var fresh = document.createElement('script');
        Array.prototype.slice.call(old.attributes).forEach(function (a) {
          fresh.setAttribute(a.name, a.value);
        });
        fresh.setAttribute('data-shelf-clone', '');
        fresh.textContent = old.textContent;
        old.parentNode.replaceChild(fresh, old);
      });
    }

    function isSoldOutButton(btn) {
      if (!btn || !btn.hasAttribute('disabled')) return false;
      var label = btn.querySelector('span');
      var soldOut = window.variantStrings && window.variantStrings.soldOut;
      return !!(label && soldOut && label.textContent.trim() === soldOut);
    }

    /* ---- variant helpers (same JSON block global.js reads) ---- */
    function getVariantData() {
      var el = slot.querySelector('variant-radios script[type="application/json"]');
      if (!el) return [];
      try { return JSON.parse(el.textContent); } catch (e) { return []; }
    }

    function selectedOptions() {
      var fieldsets = Array.prototype.slice.call(slot.querySelectorAll('variant-radios fieldset'));
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      var data = getVariantData();
      for (var i = 0; i < data.length; i++) {
        var v = data[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function formatMoney(cents) {
      var n = Math.abs(cents) / 100;
      var s = n.toFixed(2);
      if (s.slice(-3) === '.00') s = s.slice(0, -3);
      return '$' + s;
    }

    /* ---- gallery ---- */
    function loadGallery() {
      var el = slot.querySelector('[data-shelf-gallery]');
      gallery = [];
      if (el) {
        try { gallery = JSON.parse(el.textContent) || []; } catch (e) { gallery = []; }
      }
      gIndex = 0;
      updateGalleryChrome();
    }

    function updateGalleryChrome() {
      var multi = gallery.length > 1;
      if (prevBtn) prevBtn.hidden = !multi;
      if (nextBtn) nextBtn.hidden = !multi;
      if (counter) {
        counter.hidden = !multi;
        if (multi) counter.textContent = (gIndex + 1) + ' / ' + gallery.length;
      }
    }

    function preloadNeighbours() {
      if (!interacted || gallery.length < 2) return;
      [gIndex + 1, gIndex - 1].forEach(function (i) {
        var item = gallery[(i + gallery.length) % gallery.length];
        if (item && item.src) { var im = new Image(); im.src = item.src; }
      });
    }

    function showIndex(i) {
      if (!gallery.length) return;
      gIndex = (i + gallery.length) % gallery.length;
      setImage(gallery[gIndex].src, gallery[gIndex].alt);
      updateGalleryChrome();
      preloadNeighbours();
    }

    function step(delta) {
      interacted = true;
      showIndex(gIndex + delta);
    }

    function syncImageToVariant() {
      var v = findVariant(selectedOptions());
      if (!v) return;
      if (v.featured_image && v.featured_image.id) {
        for (var i = 0; i < gallery.length; i++) {
          if (gallery[i].id === v.featured_image.id) { showIndex(i); return; }
        }
      }
      if (v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src;
        setImage(src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900');
        return;
      }
      /* No image on this variant: fall back to the tab's product image. */
      var on = root.querySelector('[data-shelf-tab].is-on');
      if (on && on.dataset.image) setImage(on.dataset.image);
    }

    /* Toggle rows: reflect the checked radio and show the price difference. */
    function syncToggles() {
      var toggles = Array.prototype.slice.call(slot.querySelectorAll('[data-shelf-toggle]'));
      if (!toggles.length) return;
      var fieldsets = Array.prototype.slice.call(slot.querySelectorAll('variant-radios fieldset'));
      var opts = selectedOptions();
      toggles.forEach(function (fs) {
        var radios = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
        var btn = fs.querySelector('[data-shelf-toggle-btn]');
        if (radios.length !== 2 || !btn) return;
        var withRadio = radios[1];
        var isOn = withRadio.checked;
        btn.classList.toggle('is-on', isOn);
        btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');

        var idx = fieldsets.indexOf(fs);
        var delta = btn.querySelector('[data-shelf-toggle-delta]');
        if (idx < 0 || !delta) return;
        var withOpts = opts.slice(); withOpts[idx] = radios[1].value;
        var withoutOpts = opts.slice(); withoutOpts[idx] = radios[0].value;
        var a = findVariant(withOpts), b = findVariant(withoutOpts);
        if (a && b && typeof a.price === 'number' && typeof b.price === 'number') {
          var diff = a.price - b.price;
          delta.textContent = diff > 0 ? '+ ' + formatMoney(diff) : (diff < 0 ? '- ' + formatMoney(diff) : '');
        } else {
          delta.textContent = '';
        }
      });
    }

    /* Things delivery-estimate.js only wires up on page load. */
    function afterSwap() {
      if (typeof window.updateDeliveryEstimate === 'function') window.updateDeliveryEstimate();
      syncToggles();
      loadGallery();
      if (!('MutationObserver' in window)) return;

      var eng = slot.querySelector('#engraving');
      if (eng) {
        new MutationObserver(function () {
          if (typeof window.updateDeliveryEstimate === 'function') window.updateDeliveryEstimate();
        }).observe(eng, { attributes: true, attributeFilter: ['class'] });
      }

      var btn = slot.querySelector('button[name="add"]');
      var ship = slot.querySelector('[data-ship-estimate]');
      if (btn && ship) {
        var sync = function () {
          ship.classList.toggle('hidden', isSoldOutButton(btn));
        };
        sync();
        new MutationObserver(sync).observe(btn, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    function fetchBox(tab) {
      var handle = tab.dataset.handle;
      if (cache[handle]) return Promise.resolve(cache[handle]);
      var url = tab.dataset.url + (tab.dataset.url.indexOf('?') > -1 ? '&' : '?') + 'section_id=shelf-panel';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var box = doc.querySelector('[data-shelf-buybox]');
          var html = box ? box.outerHTML : '';
          if (html) cache[handle] = html;
          return html;
        });
    }

    function load(tab) {
      var handle = tab.dataset.handle;
      current = handle;
      root.classList.add('is-loading');
      fetchBox(tab)
        .then(function (html) {
          if (current !== handle) return;
          if (!html) {
            window.location.href = tab.dataset.url;
            return;
          }
          slot.innerHTML = html;
          runScripts(slot);
          afterSwap();
          syncImageToVariant();
          root.classList.remove('is-loading');
        })
        .catch(function () {
          root.classList.remove('is-loading');
          window.location.href = tab.dataset.url;
        });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('is-on')) return;
        tabs.forEach(function (t) {
          t.classList.remove('is-on');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-on');
        tab.setAttribute('aria-selected', 'true');
        setStatic(tab);
        load(tab);
        if (window.innerWidth < 750 && tab.scrollIntoView) {
          tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      });
    });

    /* Gallery arrows, keyboard and swipe. */
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    if (media) {
      var startX = null, startY = null;
      media.addEventListener('pointerdown', function (e) {
        if (e.target.closest('[data-shelf-prev], [data-shelf-next]')) return;
        startX = e.clientX; startY = e.clientY;
      });
      media.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        startX = startY = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
      });
      media.addEventListener('pointercancel', function () { startX = startY = null; });
      media.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { step(-1); e.preventDefault(); }
        if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
      });
    }

    /* Toggle button -> flip the radios and let variant-radios react. */
    slot.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-shelf-toggle-btn]');
      if (!btn || !slot.contains(btn)) return;
      var fs = btn.closest('[data-shelf-toggle]');
      var radios = fs ? Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')) : [];
      if (radios.length !== 2) return;
      var target = radios[1].checked ? radios[0] : radios[1];
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* Any option change: keep the toggle state, delta and image in step. */
    slot.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      syncToggles();
      syncImageToVariant();
    });

    afterSwap();
    syncImageToVariant();
  }

  function boot() {
    document.querySelectorAll('[data-shelf]').forEach(initShelf);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
